import React, { useState, useEffect, useLayoutEffect } from 'react';
import fetchAPI from '../../../common/fetchAPI';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Select, { StylesConfig } from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { ShowToast } from '../../../common/Toastr';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { formatDateWithDateAndMonthName, formatNumberCustomoriginalapiv2, parseLocalizedNumber, formatNumberCustomoriginal, validateCultureNumber, setItemStatus, headerDropDownStyles, dateFormatByAccountCulture, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';

const objDropdown = {
    projectRole: [],
    currencies: [],
    workTypes: [],
    workTypeId: 0,
    isRelod: false,
    isLoading: true
}

const AccountProjectRole = (props: any) => {
    const { state } = useLocation();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [projectRoleResponse, setProjectRoleResponse] = useState<any | ''>(objDropdown);
    const { AccountProjectId, ProjectCode, ProjectName, AccountWorkTypeId, Status, StartDate, Deadline, PermissionId } = state;
    const { decimalPlaces, accountBaseCurrencyId, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, calendarStartDay } = useAppSelector((state) => state.globalState);

    // useLayoutEffect(() => {
    //     const fetchPagePermissions = async () => {
    //         if (PermissionId && PermissionId !== '') {
    //             const res = await dispatch(getPagePermissionsAsync(PermissionId));
    //             if (!res.payload.IsList) {
    //                 navigate('../error/403');
    //             }
    //         }
    //     }
    //     fetchPagePermissions();
    // }, [dispatch, location.pathname, menuList, navigate, PermissionId]);

    useEffect(() => {
        renderAccountProjectRoles(AccountWorkTypeId);
    }, [projectRoleResponse.isRelod]);

    const renderAccountProjectRoles = async (accountWorkTypeId: number) => {
        try {
            const response = await fetchAPI(`api/V2/Projects/GetAccountProjectRoles/${AccountProjectId}/${accountWorkTypeId}`, 'GET', '', true);
            const json = await response.json();
            json['AccountProjectRole'].map((item: any) => {
                item.Error = '';
                item.BillingRate = item.BillingRate != null ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), item.BillingRate, decimalPlaces) : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces);
                item.EmployeeRate = item.EmployeeRate != null ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), item.EmployeeRate, decimalPlaces) : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces);
                item.BillingRateCurrencyId = item.BillingRateCurrencyId != null ? item.BillingRateCurrencyId : accountBaseCurrencyId;
                item.EmployeeRateCurrencyId = item.EmployeeRateCurrencyId != null ? item.EmployeeRateCurrencyId : accountBaseCurrencyId;
                item.AccountProjectRoleId = item.AccountProjectRoleId != null ? item.AccountProjectRoleId : 0;
                item.BillingTypeId = item.BillingTypeId != null ? item.BillingTypeId : json["AccountBillingType"][0].AccountBillingTypeId;
                item.AccountBillingRateId = item.AccountBillingRateId != null ? item.AccountBillingRateId : 0;
                item.IsSelected = item.NumberOfResources != null ? true : false;
                item.IsResourcesChange = false;
                // item.StartDate = item.StartDate != null ? new Date(item.StartDate) : new Date();
                // item.EndDate = item.EndDate != null ? new Date(item.EndDate) : new Date(new Date().setFullYear(new Date().getFullYear() + 1));
                item.StartDate = item.StartDate != null ? dateFormatByAccountCulture(item.StartDate, cultureInfoName.toString()) : new Date();
                item.EndDate = item.EndDate != null ? dateFormatByAccountCulture(item.EndDate, cultureInfoName.toString()) : new Date(new Date().setFullYear(new Date().getFullYear() + 1));
            });
            json["AccountCurrency"].map((item: any) => {
                item.value = item.AccountCurrencyId;
                item.label = item.CurrencyCode;
                delete item.AccountCurrencyId;
                delete item.CurrencyCode;
            });
            json["AccountWorkType"].map((item: any) => {
                item.value = item.AccountWorkTypeId;
                item.label = item.AccountWorkType;
                delete item.AccountWorkTypeId;
                delete item.AccountWorkType;
            });
            setProjectRoleResponse({
                ...projectRoleResponse,
                projectRole: json['AccountProjectRole'],
                currencies: json['AccountCurrency'],
                workTypes: json['AccountWorkType'],
                workTypeId: accountWorkTypeId == 0 ? json['AccountWorkType'][0].value : accountWorkTypeId,
                isLoading: false
            });
        } catch (error) {
            setProjectRoleResponse({
                ...projectRoleResponse,
                isLoading: false
            });
        }
    }

    const onHandleInputFields = (data: any, id: number) => {
        const index = projectRoleResponse.projectRole.findIndex((item: any) => item.AccountRoleId === id);
        const newArray = [...projectRoleResponse.projectRole];
        if (data.target.name == 'NumberOfResources') {
            if (data.target.value > 0) {
                newArray[index].NumberOfResources = data.target.value;
                newArray[index].Error = "";
                newArray[index].IsResourcesChange = true;
            } else {
                newArray[index].NumberOfResources = data.target.value;
                newArray[index].Error = 'Numeric Required';
            }
        } else if (data.target.name == 'BillingRate') {
            newArray[index].BillingRate = data.target.value;
        } else if (data.target.name == 'EmployeeRate') {
            newArray[index].EmployeeRate = data.target.value;
        } else {
        }
        setProjectRoleResponse({
            ...projectRoleResponse,
            projectRole: newArray
        });
    }

    const onChangeSelect = (data: any, filterName: any, id: number) => {
        const index = projectRoleResponse.projectRole.findIndex((item: any) => item.AccountRoleId === id);
        const newArray = [...projectRoleResponse.projectRole];
        if (filterName.name == "BillingRateCurrency") {
            newArray[index].BillingRateCurrencyId = data.value;
        } else {
            newArray[index].EmployeeRateCurrencyId = data.value;
        }
        setProjectRoleResponse({
            ...projectRoleResponse,
            projectRole: newArray
        });
    }

    const onSelectProjectRole = (e: any, id: number) => {
        const index = projectRoleResponse.projectRole.findIndex((item: any) => item.AccountRoleId === id);
        const newArray = [...projectRoleResponse.projectRole];
        newArray[index].IsSelected = e.target.checked ? true : false;
        setProjectRoleResponse({
            ...projectRoleResponse,
            projectRole: newArray
        });
    }

    const onDateChange = (date: any, name: any, id: number) => {
        const index = projectRoleResponse.projectRole.findIndex((item: any) => item.AccountRoleId === id);
        const newArray = [...projectRoleResponse.projectRole];
        if (name == "StartDate" && moment(date).format(dateInsertionFormat) > moment(newArray[index].EndDate).format(dateInsertionFormat)) {
            ShowToast('Error', t('Start date cannot be later than end date.'), "error", "toast-top-right");
        } else if (name == "EndDate" && moment(date).format(dateInsertionFormat) < moment(newArray[index].StartDate).format(dateInsertionFormat)) {
            ShowToast('Error', t('End date cannot be earlier than start date.'), "error", "toast-top-right");
        } else {
            name == "StartDate" ? (newArray[index].StartDate = date) : (newArray[index].EndDate = date);
            setProjectRoleResponse({
                ...projectRoleResponse,
                projectRole: newArray
            });
        }
    }

    const onChangeWorkType = (data: any) => {
        setProjectRoleResponse({
            ...projectRoleResponse,
            isLoading: true
        });
        renderAccountProjectRoles(data.value);
    }

    const onUpdateAccountProjectRole = async () => {
        setProjectRoleResponse({
            ...projectRoleResponse,
            isLoading: true
        });
        try {
            let tempArray: any[] = [];
            let isUpdate = true;
            projectRoleResponse.projectRole.map((item: any) => {
                if (item.NumberOfResources > 0) {
                    const normalizedEmployeeRate = parseLocalizedNumber(item.EmployeeRate);
                    const normalizedBillingRate = parseLocalizedNumber(item.BillingRate);
                    tempArray.push({
                        "IsSelected": item.IsSelected,
                        "AccountProjectRoleId": item.AccountProjectRoleId,
                        "AccountProjectId": item.AccountProjectId,
                        "AccountRoleId": item.AccountRoleId,
                        "NumberOfResources": item.NumberOfResources,
                        "BillingRate": normalizedBillingRate,
                        "BillingTypeId": item.BillingTypeId,
                        "AccountBillingRateId": item.AccountBillingRateId,
                        "StartDate": moment(item.StartDate).format(dateInsertionFormat),
                        "EndDate": moment(item.EndDate).format(dateInsertionFormat),
                        "EmployeeRate": normalizedEmployeeRate,
                        "EmployeeRateCurrencyId": item.EmployeeRateCurrencyId,
                        "BillingRateCurrencyId": item.BillingRateCurrencyId,
                        "IsResourcesChange": item.IsResourcesChange
                    })
                } else if (item.NumberOfResources <= 0 && item.IsSelected) {
                    isUpdate = false;
                } else {
                }
            })
            if (isUpdate) {
                console.log("tempArray", tempArray);
                //const normalizedEmployeeRate = parseLocalizedNumber(item.EmployeeRate);
                  //  const normalizedBillingRate = parseLocalizedNumber(item.BillingRate);
                const response = await fetchAPI(`api/V2/Projects/AccountProjectRole?AccountProjectId=${AccountProjectId}&AccountWorkTypeId=${projectRoleResponse.workTypeId}&IsSelected=${true}`, 'POST', tempArray, true);
                const json = await response.json();
                setProjectRoleResponse({
                    ...projectRoleResponse,
                    isRelod: true
                });
                Number(json.StatusCode) === 200 ? ShowToast('Success', json.ResponseMessage, "success", "toast-top-right") :
                    ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                if (Number(json.StatusCode) === 200 && AccountProjectId != 0) {
                    let obj = {
                        "AccountProjectId": AccountProjectId,
                        "ProjectCode": ProjectCode,
                        "ProjectName": ProjectName,
                        "Status": Status,
                        "StartDate": StartDate,
                        "Deadline": Deadline,
                        "ProjectBillingRateTypeId": 2,
                        "IsEditProjectTeam": true
                    }
                    // navigate('/projectteam', { state: { obj } });
                    navigate(`/projectteam/${obj.AccountProjectId}`, { state: { obj } })
                }
            } else {
                isUpdate = true;
                setProjectRoleResponse({
                    ...projectRoleResponse,
                    isLoading: false
                });
                ShowToast('Error', getValueFromResource('Number Of Resources Field Is Required.', dispatch,t), "error", "toast-top-right");
            }
        } catch (error) {
            setProjectRoleResponse({
                ...projectRoleResponse,
                isLoading: false
            });
        }
    }

    return (
        <>
            {projectRoleResponse.isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Project Roles')} */}
                        {getValueFromResource('Project Roles',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="d-flex align-items-center">
                            <Select
                                value={projectRoleResponse.workTypes.filter((x: any) => x.value === projectRoleResponse.workTypeId)}
                                className="basic-single"
                                classNamePrefix="select"
                                onChange={(e) => onChangeWorkType(e)}
                                options={projectRoleResponse.workTypes}
                                styles={headerDropDownStyles}
                            />
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => { onUpdateAccountProjectRole() }}
                        >
                            <i className="bi bi-pencil-square fs-5 me-1"></i>
                            {/* {t('Update Records')} */}
                            {getValueFromResource('Update Records',dispatch, t)}
                        </button>
                    </div>
                </div>
                <div className='mt-3'>
                    <div className="d-flex align-items-center mt-2 mb-2">
                        <a className="text-muted fw-bold me-2 fs-2">{ProjectName}</a>
                    </div>
                    <div className="d-flex flex-wrap fs-7 mb-4 pe-2">
                        <a className="text-gray-500">
                            <i className="bi bi-calendar fs-6 iconColor me-2"></i>
                            {/* {`${moment.parseZone(StartDate).format('DD MMM yy')} - ${moment.parseZone(Deadline).format('DD MMM yy')}`} */}
                            {formatDateWithDateAndMonthName(StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(Deadline, cultureInfoName.toString())}
                        </a>
                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(Status))} style={{ lineHeight: 0.8, marginLeft: 4 }}>
                            {Status}
                        </span>
                    </div>
                </div>
                <div className='card-body py-3 mt-2'>
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            <thead>
                                <tr className='thHeading align-middle'>
                                    <th style={{width:'17%'}}>
                                        {/* {t("Role")} */}
                                        {getValueFromResource('Role', dispatch, t)}

                                    </th>
                                    <th style={{width:'10%'}}>
                                        {/* {t("Number Of Resources")} */}
                                        {getValueFromResource('Number Of Resources', dispatch, t)}

                                    </th>
                                    <th style={{width:'10%'}}>
                                        {/* {t("Billing Rate Currency")} */}
                                        {getValueFromResource('Billing Rate Currency', dispatch, t)}

                                    </th>
                                    <th style={{width:'10%'}}>
                                        {/* {t("Billing Rate")} */}
                                        {getValueFromResource('Billing Rate', dispatch, t)}

                                    </th>
                                    <th style={{width:'10%'}}>
                                        {/* {t("Employee Rate Currency")} */}
                                        {getValueFromResource('Employee Rate Currency', dispatch, t)}

                                    </th>
                                    <th style={{width:'10%'}}>
                                        {/* {t("Employee Rate")} */}
                                        {getValueFromResource('Employee Rate', dispatch, t)}

                                    </th>
                                    <th style={{width:'6%'}}>
                                        {/* {t("Selected")} */}
                                        {getValueFromResource('Selected', dispatch, t)}

                                    </th>
                                    <th style={{width:'10%'}}>
                                        {/* {t("Start Date")} */}
                                        {getValueFromResource('Start Date', dispatch, t)}

                                    </th>
                                    <th style={{width:'10%'}}>
                                        {/* {t("End Date")} */}
                                        {getValueFromResource('End Date', dispatch, t)}

                                    </th>
                                    <th style={{width:'9%'}}>
                                        {/* {t("History")} */}
                                        {getValueFromResource('History', dispatch, t)}

                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {projectRoleResponse.projectRole.length > 0 && projectRoleResponse.projectRole.map((item: any, index: number) => {
                                    return (
                                        <tr key={item.AccountRoleId}>
                                            <td>
                                                <a className='text-dark fw-bold d-block'>
                                                    {item.Role}
                                                </a>
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control inputFieldAlignment"
                                                    name="NumberOfResources"
                                                    value={item.NumberOfResources}
                                                    onChange={(e) => onHandleInputFields(e, item.AccountRoleId)}
                                                />
                                                <div>
                                                    {item.Error != '' &&
                                                        <p className='errorMsg'>{item.Error as string}</p>
                                                    }
                                                </div>
                                            </td>
                                            <td>
                                                <Select
                                                    value={projectRoleResponse.currencies.filter((x: any) => x.value === item.BillingRateCurrencyId)}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    name="BillingRateCurrency"
                                                    onChange={(e, name) => onChangeSelect(e, name, item.AccountRoleId)}
                                                    options={projectRoleResponse.currencies}
                                                    styles={colourStyles}
                                                    isDisabled={item.AccountBillingRateId != 0 ? true : false}
                                                    maxMenuHeight={maxMenuHeight}
                                                    menuPlacement={index > 2 ? "top" : "bottom"}
                                                    menuPosition={'fixed'}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control inputFieldAlignment"
                                                    name="BillingRate"
                                                    value={item.BillingRate}
                                                    //onChange={(e) => onHandleInputFields(e, item.AccountRoleId)}
                                                    disabled={item.AccountBillingRateId != 0 ? true : false}
onChange={(e) => {
        const val = e.target.value;
        if (!validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            return;
        }
        onHandleInputFields(e, item.AccountRoleId);
    }}
    onBlur={(e) => {
    let val = e.target.value.trim();
    // If empty or invalid, set to 0
    if (!val || val === '') {
      const formatted = formatNumberCustomoriginal(
        cultureInfoName.toString(),
        '0',
        decimalPlaces
      );
        onHandleInputFields({ target: { name: 'BillingRate', value: formatted } }, item.AccountRoleId);
        
    } else {
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
    
//        onHandleInputFields(e, item.AccountRoleId);
            onHandleInputFields({ target: { name: 'BillingRate', value: formatted } }, item.AccountRoleId);
}
    }}
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    value={projectRoleResponse.currencies.filter((x: any) => x.value === item.EmployeeRateCurrencyId)}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    name="EmployeeRateCurrency"
                                                    onChange={(e, name) => onChangeSelect(e, name, item.AccountRoleId)}
                                                    options={projectRoleResponse.currencies}
                                                    styles={colourStyles}
                                                    isDisabled={item.AccountBillingRateId != 0 ? true : false}
                                                    maxMenuHeight={maxMenuHeight}
                                                    menuPlacement={index > 2 ? "top" : "bottom"}
                                                    menuPosition={'fixed'}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control inputFieldAlignment"
                                                    name="EmployeeRate"
                                                    value={item.EmployeeRate}
                                                    //onChange={(e) => onHandleInputFields(e, item.AccountRoleId)}
                                                    disabled={item.AccountBillingRateId != 0 ? true : false}
onChange={(e) => {
        const val = e.target.value;
        if (!validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            return;
        }
        onHandleInputFields(e, item.AccountRoleId);
    }}
    onBlur={(e) => {
    let val = e.target.value.trim();
    // If empty or invalid, set to 0
    if (!val || val === '') {
      const formatted = formatNumberCustomoriginal(
        cultureInfoName.toString(),
        '0',
        decimalPlaces
      );
        onHandleInputFields({ target: { name: 'EmployeeRate', value: formatted } }, item.AccountRoleId);
        
    } else {
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        //onHandleInputFields(e, item.AccountRoleId);
        onHandleInputFields({ target: { name: 'EmployeeRate', value: formatted } }, item.AccountRoleId);
    }
    }}
                                                />
                                            </td>
                                            <td>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox'>
                                                    <input
                                                        className='form-check-input widget-9-check'
                                                        type='checkbox'
                                                        checked={item.IsSelected}
                                                        style={{ marginLeft: 10 }}
                                                        onChange={(e) => { onSelectProjectRole(e, item.AccountRoleId) }}
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={item.StartDate}
                                                        onChange={(date) => onDateChange(date, "StartDate", item.AccountRoleId)}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark inputFieldAlignment"
                                                        calendarStartDay={calendarStartDay}
                                                        disabled={item.AccountBillingRateId != 0 ? true : false}
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray" style={{ right: 12 }}></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={item.EndDate}
                                                        onChange={(date) => onDateChange(date, "EndDate", item.AccountRoleId)}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark inputFieldAlignment"
                                                        calendarStartDay={calendarStartDay}
                                                        disabled={item.AccountBillingRateId != 0 ? true : false}
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray" style={{ right: 12 }}></i>
                                                </div>
                                            </td>
                                            <td>
                                                {item.AccountBillingRateId != 0 && <button
                                                    type="button"
                                                    className="btn btn-secondary btn-sm" style={{ width: '100px', height: '40px' }}
                                                    onClick={() => {
                                                        navigate(`/accountbillingrate/${AccountProjectId}`, {
                                                            state: {
                                                                "AccountProjectRoleId": item.AccountProjectRoleId,
                                                                "SystemBillingRateTypeId": item.SystemBillingRateTypeId,
                                                                "Id": AccountProjectId,
                                                                "ProjectName": ProjectName
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <i className="bi bi-pencil-square fs-5 me-1"></i>
                                                    {/* {t('History')} */}
                                                    {getValueFromResource('History',dispatch, t)}

                                                </button>}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {projectRoleResponse.projectRole.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}

                                    </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccountProjectRole

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 120, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}